/* eslint-env browser */

import * as React from 'react'
const PropTypes = require('prop-types')
const axios = require('axios')
const { captureException } = require('../../../../render/client/clientjs/services/sentry-service')

const Counterpart = require('@gandi/counterpart').Instance

const translate = new Counterpart()
translate.registerTranslations('en', require('./i18n/en'))
translate.registerTranslations('fr', require('./i18n/fr'))

class ResetPasswordWithTokenForm extends React.Component {
  constructor() {
    super()
    this.state = {
      password: '',
      passwordStarted: false,
      passwordConfirm: '',
      passwordConfirmStarted: false,
    }
    this.handleChange = this.handleChange.bind(this)
    this.validationState = this.validationState.bind(this)
    this.isSignupButtonEnabled = this.isSignupButtonEnabled.bind(this)
    this.submit = this.submit.bind(this)
  }

  componentWillMount() {
    if (this.props.appConfig.locale.identifierShort !== translate.getLocale()) {
      translate.setLocale(this.props.appConfig.locale.identifierShort)
    }
  }

  handleChange() {
    const passwordStarted = this.state.passwordStarted || this.passwordInput.value.length > 0
    const passwordConfirmStarted = this.state.passwordConfirmStarted || this.passwordConfirmInput.value.length > 0
    this.setState({
      password: this.passwordInput.value,
      passwordStarted,
      passwordConfirm: this.passwordConfirmInput.value,
      passwordConfirmStarted,
    })
  }

  validationState(formElementName) {
    if (formElementName === 'password') {
      if (this.state.passwordStarted && this.state.password.length < 6) {
        return 'error'
      }
    } else if (formElementName === 'passwordConfirm') {
      if (
        this.state.passwordConfirmStarted &&
        (this.state.passwordConfirm.length < 6 || this.state.passwordConfirm !== this.state.password)
      ) {
        return 'error'
      }
    }
    return undefined
  }

  isSignupButtonEnabled() {
    if (this.state.isSubmitting) {
      return false
    }
    if (!this.state.passwordStarted || !this.state.passwordConfirmStarted) {
      return false
    }
    const elementNames = ['password', 'passwordConfirm']
    const hasError = elementNames.some(elt => typeof this.validationState(elt) !== 'undefined')
    if (hasError) {
      return false
    }
    return true
  }

  submit(e) {
    e.preventDefault()
    if (this.state.isSubmitting) {
      return
    }
    const newState = this.state
    newState.errorMessage = undefined
    newState.successMessage = undefined
    newState.isSubmitting = true
    this.setState(newState)
    const refToThis = this

    axios
      .post(`/api/passwordResetTokens/${this.props.resetToken}`, this.state)
      .then(function(/* res */) {
        const newState2 = refToThis.state
        newState2.isSubmitting = false
        newState2.successMessage = 'successMessage'
        refToThis.setState(newState2)
      })
      .catch(function(err) {
        captureException(err)
        const newState2 = refToThis.state
        newState2.isSubmitting = false
        newState2.errorMessage = 'unknownError'
        refToThis.setState(newState2)
      })
  }

  signupButtonTitle() {
    return this.state.isSubmitting
      ? translate.translate('submit.loading')
      : translate.translate('submit.changePassword')
  }

  render() {
    return (
      <form className="form form-horizontal" onSubmit={this.submit}>
        <div className="field is-horizontal">
          <div className="field-label is-normal">
            <label className="label" htmlFor="input-password-reset-password">
              {translate.translate('password.label')}
            </label>
          </div>
          <div className="field-body">
            <div className="field">
              <div className="control">
                <input
                  className={`input${this.validationState('password') ? ' is-danger' : ''}`}
                  type="password"
                  id="input-password-reset-password"
                  placeholder={translate.translate('password.label')}
                  ref={c => {
                    this.passwordInput = c
                  }}
                  onChange={this.handleChange}
                  autoCapitalize="off"
                  autoCorrect="off"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="field is-horizontal">
          <div className="field-label is-normal">
            <label className="label" htmlFor="input-password-confirm-reset-password">
              {translate.translate('passwordConfirm.label')}
            </label>
          </div>
          <div className="field-body">
            <div className="field">
              <div className="control">
                <input
                  className={`input${this.validationState('passwordConfirm') ? ' is-danger' : ''}`}
                  type="password"
                  id="input-password-confirm-reset-password"
                  placeholder={translate.translate('passwordConfirm.label')}
                  ref={c => {
                    this.passwordConfirmInput = c
                  }}
                  onChange={this.handleChange}
                  autoCapitalize="off"
                  autoCorrect="off"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="form-group columns is-mobile is-multiline is-centered">
          <div
            className="column is-12 has-text-weight-bold has-text-danger"
            style={{ display: this.state.errorMessage ? '' : 'none' }}
          >
            {this.state.errorMessage && translate.translate(this.state.errorMessage)}
          </div>
          <div
            className="column is-12 has-text-weight-bold has-text-primary"
            style={{ display: this.state.successMessage ? '' : 'none' }}
          >
            {this.state.successMessage && (
              <div dangerouslySetInnerHTML={{ __html: translate.translate(this.state.successMessage) }} />
            )}
          </div>
          <div
            className="column is-12 text-right"
            style={{ marginTop: 8, display: this.state.successMessage ? 'none' : '' }}
          >
            <button className="button is-primary" type="submit" disabled={!this.isSignupButtonEnabled()}>
              {this.signupButtonTitle()}
            </button>
          </div>
        </div>
      </form>
    )
  }
}

ResetPasswordWithTokenForm.propTypes = {
  appConfig: PropTypes.object.isRequired,
  resetToken: PropTypes.string.isRequired,
}

module.exports = ResetPasswordWithTokenForm
